import { useQuery } from "@tanstack/react-query";
import { getUserRequestList } from "api/userRequest";

export const useUserRequestList = (params = {}) =>
  useQuery({
    queryKey: ["user-request-list", params],
    queryFn: () => getUserRequestList(params),
    select: (res) => ({
      list: res?.data?.user_request_list ?? [],
      count: res?.data?.pagination_details?.count ?? 0,
    }),
    staleTime: 1000 * 60,
  });